import { useQuery } from "@tanstack/react-query";

import { customerPaymentMethodArraySchema } from "~/shared/schemas/invoice-schema.ts";
import { apiRoutes } from "~/shared/services/api/api-routes.ts";
import { getAndValidate } from "~/shared/services/api/fetch-client.ts";

const fetchCustomerPaymentMethods = async (signal: AbortSignal) => {
	const signalOptions = signal ? { signal } : undefined;

	try {
		const resp = await getAndValidate(
			apiRoutes.GETCUSTOMERPAYMENTMETHODS,
			customerPaymentMethodArraySchema,
			signalOptions,
		);

		if (resp.success) {
			return resp.data;
		} else {
			console.error("Failed to fetch customer payment methods:", resp.error);
			return null;
		}
	} catch (error) {
		console.error("Failed to fetch customer payment methods:", error);
		return null;
	}
};

export const useGetCustomerPaymentMethods = ({
	enabled = true,
}: { enabled?: boolean } = {}) => {
	const { data, isLoading, error } = useQuery({
		queryKey: ["customerPaymentMethods"],
		queryFn: async ({ signal }) => {
			return await fetchCustomerPaymentMethods(signal);
		},
		enabled,
		staleTime: 0,
		gcTime: 0,
	});
	return {
		paymentMethods: data,
		isLoading,
		error,
	};
};
